export const StorageKey = "ftic_data";

export const TweetText =
  "🐮 cow cow cow cow COW COW! COW! COW!! www.FindTheInvisibleCow.com by @scriptist";
